/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Decks_Viewed_ByInputs */



/**
* | output |
* | --- |
* | "Viewed by {names}" |
*
* @param {Decks_Viewed_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_viewed_by = /** @type {((inputs: Decks_Viewed_ByInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Viewed_ByInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Consultée par ${i?.names}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Consultada por ${i?.names}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Consultada por ${i?.names}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Consultata da ${i?.names}`)
	return /** @type {LocalizedString} */ (`Viewed by ${i?.names}`)
});